import React, {useEffect, useState} from "react";

import TableTd from "./td/TableTd";
import TableTr from "./tr/TableTr";
import TableTdPrice from "./td/TableTdPrice";
import TableTdOrder from "./td/TableTdOrder";
import TableTdViewDetail from "./td/TableTdViewDetail";
import TableTdDelivery from "./td/TableTdDelivery";
import TableTdArticleNumber from "./td/TableTdArticleNumber";
import TableTrProductDescriptions from "./tr/TableTrProductDescriptions";

const TableBody = (props) => {
    const {
        data,
        popup,
        showSpecials,
        isSpecial,
        urlIconCar,
        productPriceList,
        loadingPriceList,
        previouslyOrderedProducts,
        loadingPreviouslyOrderedProducts,
        contactDetails,
        showOrderButton,
    } = props;

    return (
        <tbody key={'product_details_tbody_0'}>
        {
            data['body'].map((item, index) => {
                return (
                    <Trs
                        key={index}
                        lang={data.lang}
                        item={item}
                        popup={popup}
                        isSpecial={isSpecial}
                        showSpecials={showSpecials}
                        urlIconCar={urlIconCar}
                        productPriceList={productPriceList}
                        loadingPriceList={loadingPriceList}
                        previouslyOrderedProducts={previouslyOrderedProducts}
                        loadingPreviouslyOrderedProducts={loadingPreviouslyOrderedProducts}
                        contactDetails={contactDetails}
                        showOrderButton={showOrderButton}
                    />
                )
            })
        }
        </tbody>
    )
}

const Trs = (props) => {
    return (
        <>
            <TrTds
                {...props}
            />
            <TableTrProductDescriptions productDescriptions={props?.item?.productDescription ?? []}/>
        </>
    )
}

const TrTds = (props) => {
    const {
        item,
        lang,
        popup,
        showSpecials,
        isSpecial,
        urlIconCar,
        productPriceList,
        loadingPriceList,
        previouslyOrderedProducts,
        loadingPreviouslyOrderedProducts,
        contactDetails,
        showOrderButton,
    } = props;

    return (
        <TableTr
            key={`product_key_tr_${item.id}`}
            productKey={item.id}
            tr={item}
            isSpecial={isSpecial}
            popup={popup}
        >
            {
                Object.values(item.data).map((td, indexTd) => {
                    const keysTd = Object.keys(td);
                    const keyUnique = `product_key_tr_${item.id}_td_${indexTd}`;
                    const priceKey = `${item.product_code ?? ''}-${item.unit_code ?? ''}`;
                    const width = keysTd.includes('width') ? td['width'] : '';
                    const colSpan = keysTd.includes('col') ? td['col'] : '1';

                    if (keysTd.includes('special') || keysTd.includes('price')) {
                        if (keysTd.includes('special')) {
                            if (td.special === 'order') {
                                if(showSpecials && !showOrderButton) {
                                    return null;
                                }
                                return (
                                    <TdOrderWrapperGA
                                        key={keyUnique}
                                        isSpecial={isSpecial}
                                        item={item}
                                        showSpecials={showSpecials}
                                        productKey={item.product_code}
                                        priceKey={priceKey}
                                        lang={lang}
                                        urlIconCar={urlIconCar}
                                        productPriceList={productPriceList}
                                        loadingPriceList={loadingPriceList}
                                        contactDetails={contactDetails}
                                    />
                                );
                            } else if (td.special === 'article_number') {
                                return (
                                    <TableTdArticleNumber
                                        previouslyOrderedProductStatus={previouslyOrderedProducts[item.product_code] === true}
                                        loadingPreviouslyOrderedProducts={loadingPreviouslyOrderedProducts}
                                        key={keyUnique}
                                        td={td}
                                    />
                                );
                            } else if (td.special === 'debtor_article_number') {
                                return (
                                    <TableTd key={keyUnique} td={td}/>
                                );
                            } else if (showSpecials) {
                                if (td.special === 'view-detail') {
                                    return (
                                        <TableTdViewDetail
                                            key={keyUnique}
                                            objectName={null}// TODO find place of this variable
                                            lang={lang}
                                            url={`${td['url_segment']}/${item.id}`}
                                        />
                                    )
                                } else {
                                    return (
                                        <TableTdDelivery
                                            productCode={item.product_code}
                                            unitCode={item.unit_code}
                                            key={keyUnique}
                                        />
                                    )
                                }
                            }

                        } else if (keysTd.includes('price') && showSpecials) {
                            return (
                                <TableTdPrice
                                    key={keyUnique}
                                    priceKey={priceKey}
                                    width={width}
                                    colSpan={colSpan}
                                    productPriceList={productPriceList}
                                    loadingPriceList={loadingPriceList}
                                />
                            )
                        }
                    } else {
                        return (
                            <TableTd key={keyUnique} td={td}/>
                        )
                    }
                })
            }
        </TableTr>
    )
}

const TdOrderWrapperGA = (props) => {
    const {
        isSpecial,
        item,
        showSpecials,
        productKey,
        priceKey,
        lang,
        urlIconCar,
        productPriceList,
        loadingPriceList,
        contactDetails,
    } = props;

    const price = productPriceList[priceKey]?.price;
    const [priceValue, setPriceValue] = useState(price);
    const [gaData, setGaData] = useState(JSON.parse(item.ga_data));

    useEffect(function () {
        if (!priceValue && !loadingPriceList) {
            const gaDataMutated = JSON.parse(JSON.stringify(gaData));
            gaDataMutated.price = price;
            setGaData(gaDataMutated);
            setPriceValue(price);
        }
    }, [price, loadingPriceList]);

    const isOrdered = checkIsOrdered(productPriceList, priceKey);
    return (
        <td>
            <TableTdOrder
                item={item}
                isSpecial={isSpecial}
                cart={isOrdered}
                gaData={JSON.stringify(gaData)}
                login={!showSpecials}
                productKey={productKey}
                lang={lang}
                partno={item.product_partno}
                urlIconCar={urlIconCar}
                contactDetails={contactDetails}
                loadingPriceList={loadingPriceList}
            />
        </td>
    )
}

const checkIsOrdered = (productPriceList, product_key) => {
    if (!productPriceList || !product_key) {
        return false;
    }
    return !!(checkKey(productPriceList, product_key) && productPriceList[product_key]?.price !== 'Op aanvraag')
}

const checkKey = (obj, keyName) => {
    if (!obj) {
        return false;
    }

    return Object.keys(obj).indexOf(keyName.toString()) !== -1;
};

export default TableBody;
